import { isEmpty } from 'lodash';

import { ColumnIds } from 'enums';
import { Season } from 'features/seasons';

import { CompetitorWithRoundIndex } from './DrawsTypes';

export const BYE_COMPETITOR_ID = -1;

export type DrawCompetitor = { id?: number; isTbd?: boolean };

export const isByeCompetitor = (competitor?: DrawCompetitor) =>
  competitor?.id === BYE_COMPETITOR_ID;

export const isTbdCompetitor = (competitor?: DrawCompetitor) => Boolean(competitor?.isTbd);

export const isPlaceholderCompetitor = (competitor?: DrawCompetitor) =>
  isByeCompetitor(competitor) || isTbdCompetitor(competitor);

export const isRealCompetitor = (competitor?: DrawCompetitor) =>
  Boolean(competitor?.id && !isPlaceholderCompetitor(competitor));

export const getPlayerPositionNumber = (fixtureIndex: number, competitorIndex: number): number =>
  fixtureIndex * 2 + competitorIndex + 1;

/** Splits doubles names formatted as "Partner1/Partner2" into display lines. */
export const getCompetitorNameLines = (name?: string): string[] => {
  if (!name) {
    return [];
  }

  const parts = name
    .split('/')
    .map(part => part.trim())
    .filter(Boolean);

  return parts.length > 1 ? parts : [name];
};

export const getCompetitorFilters = (
  season: Season,
  competitionType: string,
  currentCompetitors: CompetitorWithRoundIndex[],
  roundIndex: number,
  metadataProperties?: { name: string; value: string }[],
): PaginationFilter[] => {
  const competitionTypeValue =
    metadataProperties?.find(data => data.name === 'CompetitionType')?.value || competitionType;

  const defaultFilters: PaginationFilter[] = [
    {
      columnId: ColumnIds.SportId,
      condition: 'equals',
      value: season.sport.id,
    },
    {
      columnId: competitionTypeValue === 'Player Cup' ? 'person.genderType' : 'genderType',
      condition: 'equals',
      value: season.genderType,
    },
    {
      columnId: competitionTypeValue === 'Player Cup' ? 'person.isActive' : 'competitorStatusType',
      condition: 'equals',
      value: competitionTypeValue === 'Player Cup' ? 'True' : 'Active',
    },
  ];

  const competitorFilter: PaginationFilter[] = !isEmpty(currentCompetitors)
    ? [
        {
          columnId: ColumnIds.Id,
          condition: 'nin',
          value: currentCompetitors
            .filter(x => x.roundIndex === roundIndex)
            .map(x => x.competitors)
            .join(','),
        },
      ]
    : [];
  if (competitorFilter[0]?.value === '') {
    return defaultFilters;
  }
  return [...defaultFilters, ...competitorFilter];
};
